if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // btn capitalize
    document.querySelectorAll(".btn , .btn-white").forEach(btn => {
        let txtCapitalize =  btn.textContent.charAt(0).toUpperCase() + btn.textContent.slice(1).toLowerCase();
        btn.innerText = txtCapitalize;
    });

   // slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
    let allSwipper =[];

	document.querySelectorAll('.swiper-js').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

        //custom count
        if(swiper.passedParams.customcount){
            let countcontainerall = document.querySelectorAll(`${swiper.passedParams.customcount}`);
            countcontainerall.forEach((element) => {element.innerHTML = `0${swiper.realIndex + 1}`});
            swiper.on('slideChange', () => {
                countcontainerall.forEach((element) =>{
                    element.innerHTML = `0${swiper.realIndex + 1}`;
                });
            });
        }

	});

    //custom swiper controller
    allSwipper.forEach((swiper) => {
        const customControl = swiper.passedParams.customcontrol;
        if (customControl) {
            const targetIds = customControl.substr(1).split(" ");
            const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
            if (targetSwipers.length > 0) {
                swiper.controller.control = targetSwipers;
                //TODO: more the two swiper
                // targetSwipers.forEach((targetSwiper) => { 
                //     console.log(targetSwiper.controller);
                //     targetSwiper.controller.control = [...new Set([swiper, ...targetSwiper.controller.control || []])];
                // });
            }
        }
    });


    //accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js h2");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {
            element.target.classList.toggle("active");
            element.target.nextElementSibling.classList.toggle("active");
		});
	});

})();

/** Disables keyboard navigation in menu links**/
document.addEventListener("DOMContentLoaded", () => {
    const mobileNav = document.querySelector(".burger-menu__nav");

    if (mobileNav) {
        const navLinks = mobileNav.querySelectorAll("a");

        navLinks.forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
    }
});
